module.exports = new __parcel__URL__("addPeople.cb761064.svg").toString();